import {useState} from "react";
import AutoHoaForm from "./AutoHoaForm";

const CreateAutoHoa = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Auto Hoa", url: "/auto-hoa"},
        {content: "Add Auto Hoa", url: ""},
    ]);

    return (
        <>
            <AutoHoaForm crumbs={crumbs} title={"Add Auto HOA"} btnText={"Create"}/>
        </>
    )
}
export default CreateAutoHoa;